module.exports = __webpack_public_path__ + "static/media/personajestyp.9ddf65b7.svg";